import { useEffect, useRef } from "react";

interface UseIntervalProps {
  delay: number;
  shouldPoll?: boolean;
  timeout: number;
  callback: () => void;
}

export function useInterval({
  callback,
  delay,
  timeout,
  shouldPoll,
}: UseIntervalProps) {
  const savedCallback = useRef(callback);
  const intervalRef = useRef<NodeJS.Timeout>();
  const timeOutRef = useRef<NodeJS.Timeout>();

  // Remember the latest callback if it changes.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  const stop = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    clearTimeout(timeOutRef.current);
  };

  // Set up the interval.
  useEffect(() => {
    if (shouldPoll) {
      savedCallback.current();
    }

    intervalRef.current = setInterval(() => {
      if (shouldPoll) {
        savedCallback.current();
      }
    }, delay);

    timeOutRef.current = setTimeout(() => {
      stop();
    }, timeout);

    return () => {
      stop();
    };
  }, [delay, shouldPoll, timeout]);
}
